import Grid from "@mui/material/Grid"
import dynamic from "next/dynamic"

const CategorySortSelect = dynamic(() => import("./CategorySortSelect"));

const CategorySort = () => {
    return (
        <Grid xs={4} item>
            <CategorySortSelect />
        </Grid>
    )
}

export default CategorySort